/**
 * React Query mutation for marking a match/chat as read
 */

import { matchesService } from "@features/messaging/services/matchesService";
import { matchesQueryKeys } from "@shared/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface MarkMatchAsReadVariables {
  chatId: string;
  userId: string;
}

/**
 * Hook to mark a match (chat) as read. Updates chat document and invalidates match queries so list refetches.
 */
export function useMarkMatchAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: MarkMatchAsReadVariables) => {
      await matchesService.markMatchAsRead(variables.chatId, variables.userId);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: matchesQueryKeys.allMatches(variables.userId) });
    },
  });
}
